﻿import { defineComponent, onMounted, onBeforeUnmount, ref } from 'vue';

declare global {
  interface Window {
    turnstile: {
      render: (
        container: HTMLElement,
        options: {
          sitekey: string;
          callback?: (token: string) => void;
          'error-callback'?: () => void;
          'expired-callback'?: () => void;
          theme?: 'light' | 'dark' | 'auto';
        }
      ) => string;
      remove: (widgetId: string) => void;
      reset: (widgetId?: string) => void;
    };
  }
}


export default defineComponent({
  name: 'Turnstile',
  emits: ['verified'],
  setup(_, { emit }) {
    const turnstileContainer = ref<HTMLElement | null>(null);
    let widgetId: string | null = null;

    const GetTurnstyleKey = (): string => {
        return String(import.meta.env.VITE_TURNSTILE_KEY);
    };

    const renderTurnstile = () => {
      if (window.turnstile && turnstileContainer.value) {
        widgetId = window.turnstile.render(turnstileContainer.value, {
          sitekey: GetTurnstyleKey(),
          callback: (token: string) => {
            emit('verified', token);
          },
          theme: 'light', // optional
        });
      }
    };

    

    onMounted(() => {
      if (window.turnstile) {
        renderTurnstile();
      } else {
        const interval = setInterval(() => {
          if (window.turnstile) {
            clearInterval(interval);
            renderTurnstile();
          }
        }, 100);
      }
    });

    onBeforeUnmount(() => {
      if (widgetId && window.turnstile) {
        window.turnstile.remove(widgetId);
      }
    });

    return {
      turnstileContainer
    };

  }
});
